import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "b-preview-no-event h-flex h-flex-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "b-preview-no-event__text h-flex h-flex-dir-column h-flex-justify-start h-ml-50" }
const _hoisted_4 = { class: "h-m-0" }
const _hoisted_5 = { class: "h-mt-5 h-mb-0" }
const _hoisted_6 = { class: "h-mt-40 h-flex h-flex-justify-start" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FwButton = _resolveComponent("FwButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.requireImage(`add-event.svg`)
    }, null, 8, _hoisted_2),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t('NO.EVENT.PREVIEW.ADMIN.TITLE')), 1),
      _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.userPermissionOnlyAdmin ?
                _ctx.$t('NO.EVENT.PREVIEW.ADMIN.TITLE.START') :
                _ctx.$t('NO.EVENT.PREVIEW.TRADITIONAL.TITLE.START')), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FwButton, {
          borderRadiusType: "small-border",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit("createFirstEventPopup")))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('NO.EVENT.PREVIEW.ADMIN.TRADITIONAL.CREATE')), 1)
          ]),
          _: 1
        }),
        (_ctx.userPermissionOnlyAdmin)
          ? (_openBlock(), _createBlock(_component_FwButton, {
              key: 0,
              class: "h-ml-20",
              borderRadiusType: "small-border",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit("closeNoEventPreview")))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('NO.EVENT.PREVIEW.ADMIN.ACCESS')), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}